export interface TranslatableText {
  en: string;
  us: string;
  de: string;
}

export enum CustomizableBannerType {
  ORDER_DEADLINE = 'order-deadline',
  PROMOTION = 'promotion',
  ANNOUNCEMENT = 'announcement'
}

export type CountryCode = 'DE' | 'AT' | 'CH';

export type LaboratoryName = 'nPhoto' | 'Picanova' | 'PFE' | 'Scrappbook Exclusive';

export interface ILaboratoryProduct {
  productGroup: TranslatableText;
  slug: string;
  deadline: Date;
}

export interface ILaboratoriesByLab {
  nPhoto: ILaboratoryProduct[];
  Picanova: ILaboratoryProduct[];
  PFE: ILaboratoryProduct[];
  'Scrappbook Exclusive': ILaboratoryProduct[];
}

export interface ILaboratories {
  DE: ILaboratoriesByLab;
  AT: ILaboratoriesByLab;
  CH: ILaboratoriesByLab;
}

export interface IPopupContent {
  title: TranslatableText;
  countryLabels: {
    DE: TranslatableText;
    AT: TranslatableText;
    CH: TranslatableText;
  };
}

export interface ICountryContent {
  title: TranslatableText;
  intro: TranslatableText;
  footerDigitalFiles: TranslatableText;
  footerPayment: TranslatableText;
  popupLinkText: TranslatableText;
  popup: IPopupContent;
}

export interface IBannerContent {
  DE: ICountryContent;
  AT: ICountryContent;
  CH: ICountryContent;
}

export interface ICustomizableBanner {
  id: string;
  type: CustomizableBannerType;
  title: TranslatableText;
  showUntil: Date;
  enabled: boolean;
  laboratories: ILaboratories;
  content: IBannerContent;
}
